var map = {
	"./en_US": [
		"./src/locales/lang/en_US.js",
		"lang-en_US"
	],
	"./en_US.js": [
		"./src/locales/lang/en_US.js",
		"lang-en_US"
	],
	"./ko_KR": [
		"./src/locales/lang/ko_KR.js",
		"lang-ko_KR"
	],
	"./ko_KR.js": [
		"./src/locales/lang/ko_KR.js",
		"lang-ko_KR"
	],
	"./zh_CN": [
		"./src/locales/lang/zh_CN.js",
		"lang-zh_CN"
	],
	"./zh_CN.js": [
		"./src/locales/lang/zh_CN.js",
		"lang-zh_CN"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/locales/lang lazy recursive ^\\.\\/.*$";
module.exports = webpackAsyncContext;